import React, {useEffect, useState} from 'react'
import AccountActivityCard from './AccountActivityCard'
import AccountPaymentCard from './AccountPaymentCard'
import AccountLeaseCard from './AccountLeaseCard'
import AccountBalanceCard from './AccountBalanceCard'
import {useAccountContext} from '../layout/AccountLayout'
import {useSearchParams} from 'react-router-dom'
import {
  useGetBillingActivityQuery,
  useGetPaymentAccountsQuery
} from '../../services/residentPortalApi'
import {getLogger} from '../../services/logging'

const logger = getLogger('AccountPage')

const AccountPage = () => {
  const {account, accountId, reservation} = useAccountContext()
  const propertyId = reservation.property.id
  const leaseSignatureId = account.leaseSignatureId
  const [searchParams] = useSearchParams()
  const refresh = searchParams.get('refresh') === 'true'
  const [pollCount, updatePollCount] = useState(3)
  const paymentAccountsQuery = useGetPaymentAccountsQuery(propertyId)
  const billingActivityQuery = useGetBillingActivityQuery({
    propertyId,
    reservationId: account.reservationId
  })

  // poll for payments w/ max number of attempts
  useEffect(() => {
    if (refresh && pollCount > 0) {
      const {refetch} = billingActivityQuery
      setTimeout(() => {
        logger.logInfo('Polling for payments...', {pollCount})
        refetch()
        updatePollCount(pollCount - 1)
      }, 15000)
    }
  }, [refresh, pollCount])

  return (
    <section className="mt-4">
      <div className="flex flex-col lg:flex-row gap-2 mb-2">
        <AccountLeaseCard
          reservation={reservation}
          leaseSignatureId={leaseSignatureId}
          className="w-full lg:w-1/3"
        />
        <AccountBalanceCard
          accountId={accountId}
          reservation={reservation}
          billingActivityQuery={billingActivityQuery}
          className="w-full lg:w-1/3"
        />
        <AccountPaymentCard
          accountId={accountId}
          reservation={reservation}
          paymentAccountsQuery={paymentAccountsQuery}
          className="w-full lg:w-1/3"
        />
      </div>
      <AccountActivityCard
        accountId={accountId}
        billingActivityQuery={billingActivityQuery}
        className="w-full"
      />
    </section>
  )
}

export default AccountPage
